import React from 'react';

const LoadingScreen = () => {
  return (
    <div className="fixed inset-0 bg-[#4a1a1f] flex items-center justify-center z-[9999]">
      <div className="text-center">
        {/* Logo */}
        <div className="mb-8 animate-pulse">
          <img
            src="https://firebasestorage.googleapis.com/v0/b/rizzahra-43273.firebasestorage.app/o/74e4297d-1681-4176-a129-faaf9c90eaec-removebg-preview.png?alt=media&token=cd033554-61ba-4194-aacf-06fc9f7b4eb0"
            alt="Rizzahra"
            className="h-24 w-24 mx-auto object-contain"
          />
        </div>

        {/* Spinner */}
        <div className="flex justify-center mb-4">
          <div className="relative">
            <div className="w-16 h-16 border-4 border-[#c9a86a] border-t-transparent rounded-full animate-spin"></div>
          </div>
        </div>

        {/* Loading Text */}
        <p className="text-[#c9a86a] text-lg font-semibold uppercase tracking-wider animate-pulse">
          Loading...
        </p>
        <p className="text-gray-400 text-sm mt-2">
          Preparing your shopping experience
        </p>
      </div>
    </div>
  );
};

export default LoadingScreen;
